import { ECOPROTOKEN_CLAIMS, LOCALSESSIONDATAKEYS } from "../../constants/AppConstants";
import { getDeviceInfoForAddNewDevice } from "../../constants/AppMethod";
import { getUserDataByKey, getUserSessionData, getLocalSessionData } from "../Authentication/handleUserSession";

const UpdateUserEnrolledDevicePayload = (updateInfo) => {
  const UID = getUserSessionData(ECOPROTOKEN_CLAIMS.USERID);
  const {
    deviceName,
    deviceAddress,
    editDeviceDetail
  } = updateInfo;

  const deviceId = editDeviceDetail ? getLocalSessionData(LOCALSESSIONDATAKEYS.DEVICE_ID) : getDeviceInfoForAddNewDevice(LOCALSESSIONDATAKEYS.DEVICE_ID);
  const firstName = getUserDataByKey('firstName', 'personal_details');
  const lastName = getUserDataByKey('lastName', 'personal_details');

  const payload = {
    userId: UID || null,
    FirstName: firstName || "",
    LastName: lastName || "",
    deviceId: deviceId || null,
    deviceName: deviceName || "",
    deviceAddress: deviceAddress === null
      ? null
      : {
        addressId: deviceAddress?.addressId || 0,
        addressLine1: deviceAddress?.addressLine1 || "",
        addressLine2: deviceAddress?.addressLine2 || "",
        cityTown: deviceAddress?.cityTown || "",
        state: deviceAddress?.state || "",
        country: deviceAddress?.country || "",
        postCode: deviceAddress?.postCode || "",
        companyName: deviceAddress?.companyName || "",

        // do not send empty string as address name value.
        addressName: deviceAddress?.addressName || null,
      },
  };
  return payload;
};

export default UpdateUserEnrolledDevicePayload;
